import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import type { IBlogList } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createBlogList(payload: Partial<IBlogList>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BLOG_LIST.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBlogList(id: number, payload: Partial<IBlogList>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BLOG_LIST.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
